import SEOHead from '../components/SEOHead'
import LeadCaptureForm from '../components/LeadCaptureForm'

export default function QuotePage() {
  return (
    <>
      <SEOHead
        title="Get a Quote — Nala"
        description="Tell us about your pet and your zip code. A care coordinator will get back to you with pricing and the next available visit."
        canonical="https://nala.vet/quote"
      />

      <section className="bg-gradient-to-br from-brand-50 to-white py-16 lg:py-24 px-4">
        <div className="max-w-4xl mx-auto grid lg:grid-cols-2 gap-10 items-start">
          <div>
            <p className="text-brand-700 font-semibold text-xs uppercase tracking-widest mb-3">
              Free, no commitment
            </p>
            <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight mb-4">
              Get a quote and book your first visit
            </h1>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              Tell us a bit about your pet and where you live. A care
              coordinator will follow up within one business day with
              pricing, availability, and answers to any questions.
            </p>

            <ul className="space-y-3">
              {[
                'Licensed, insured veterinarians',
                'Same-day sick visits in most markets',
                'Transparent flat-fee pricing',
                'No waiting rooms — we come to you',
              ].map((line) => (
                <li key={line} className="flex items-start gap-3 text-sm text-gray-700">
                  <span className="mt-1 w-5 h-5 rounded-full bg-brand-100 text-brand-700 flex items-center justify-center text-xs font-bold shrink-0">
                    ✓
                  </span>
                  {line}
                </li>
              ))}
            </ul>

            <p className="text-xs text-gray-400 mt-8">
              Prefer to call? Look for the number in the footer of any page.
            </p>
          </div>

          <div>
            <LeadCaptureForm variant="card" />
          </div>
        </div>
      </section>
    </>
  )
}
